<div class="row justify-content-center">
  <div class="col-22">
    @if (productCards?.length > 0 && showRange) {
      <sd-component-wrapper
        [content]="wrapperContent"
        [themesConfig]="lameConfig?.benefits?.backgroundTheme"
        [brand]="brand"
      >
        @if (productCards?.length > 0 && showRange) {
          <ng-container sd-component-wrapper-component>
            <sd-show-more
              [itemTemplate]="itemTmpl"
              [size]="sizesEnum.s"
              [showSize]="1"
              [showedRow]="showedRow"
              [items]="productCards"
            >
              <ng-template #itemTmpl let-item>
                <sd-product-card
                  [productInfo]="item"
                  (cart)="addToCart($event)"
                  (notify)="notifyMe($event)"
                  (productSellerModal)="openSellerModal()"
                  (productClicked)="onProductClick($event)"
                  [twicPicsAutoSize]="false"
                  [brand]="brand"
                  [isSSR]="isSSR"
                />
              </ng-template>
            </sd-show-more>
          </ng-container>
        }
      </sd-component-wrapper>
    }

    <sd-product-seller-modal [(isOpened)]="isOpenedSellerModal" />

    <wc-product-notification-modal
      [productCode]="notifyProduct"
      [productName]="notifyProductName"
      [(notifyModalOpened)]="notifyModalOpened"
    />
  </div>
</div>
